var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGetHelp = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23,
    fill: "#574EFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 23.279 37.325 C 24.068 37.325 24.734 37.052 25.28 36.508 C 25.823 35.963 26.095 35.298 26.095 34.509 C 26.095 33.721 25.823 33.054 25.28 32.509 C 24.734 31.965 24.068 31.692 23.279 31.692 C 22.491 31.692 21.824 31.965 21.28 32.509 C 20.735 33.054 20.463 33.721 20.463 34.509 C 20.463 35.298 20.735 35.963 21.28 36.508 C 21.824 37.052 22.491 37.325 23.279 37.325 Z M 23.617 14.119 C 24.556 14.119 25.373 14.419 26.068 15.02 C 26.762 15.621 27.109 16.372 27.109 17.273 C 27.109 18.099 26.857 18.831 26.349 19.469 C 25.843 20.109 25.269 20.709 24.631 21.273 C 23.767 22.024 23.007 22.85 22.351 23.751 C 21.693 24.652 21.364 25.666 21.364 26.792 C 21.364 27.318 21.561 27.76 21.956 28.116 C 22.351 28.473 22.81 28.65 23.336 28.65 C 23.899 28.65 24.378 28.463 24.772 28.087 C 25.167 27.712 25.419 27.243 25.532 26.68 C 25.682 25.891 26.02 25.187 26.546 24.567 C 27.071 23.948 27.635 23.356 28.235 22.793 C 29.1 21.967 29.841 21.065 30.461 20.089 C 31.08 19.113 31.391 18.024 31.391 16.822 C 31.391 14.907 30.611 13.34 29.052 12.119 C 27.495 10.899 25.682 10.289 23.617 10.289 C 22.19 10.289 20.829 10.589 19.533 11.19 C 18.238 11.791 17.253 12.71 16.577 13.949 C 16.314 14.4 16.229 14.879 16.323 15.387 C 16.417 15.893 16.67 16.277 17.084 16.54 C 17.609 16.841 18.154 16.935 18.718 16.822 C 19.281 16.71 19.749 16.39 20.125 15.864 C 20.538 15.301 21.055 14.87 21.674 14.57 C 22.294 14.269 22.941 14.119 23.617 14.119 Z",
    fill: "white",
    style: {}
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGetHelp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/get_help.6c9a7a45168dab5c01207e8816ea89aa.svg";